<div class="notice">
  @if (showMessages) {
    <ng-container>
<!-- /* TODO: notificationmessages is not provided by the pg-notice component */ -->
<!--         <ng-container *ngFor="let msg of notificationmessages">
            <div class="row">
              <div class="col">
                <p-message
                  severity={{msg.severity}}
                  text={{msg.detail}}>
                </p-message>
              </div>
            </div>
          </ng-container> -->


        <!-- <p-panel header="You have notices!" [toggleable]="true" [collapsed]="false">
            <div class="noticeelement alert-critical">Notice One</div>
            <div class="noticeelement alert">Notice Two</div>
            <div class="noticeelement info">Notice Three</div>
          </p-panel>

          <div>You have SignalR notices!
            <div>{{notification}}</div>
          </div> -->

    </ng-container>
  }

  <app-breadcrumb [enableSwitchTo]="enableBreadcrumbSwitcher"></app-breadcrumb>

  <ng-container *ngIf="isUserLoggedIn()">
      <div *ngIf="!menuLoading && !hideLogout" id="app-logout" (click)="logoutUser()">
        <!-- <a href="">Logout</a> -->
        <span>Logout</span>
      </div>
  </ng-container>

</div>
